import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';

/** Register / log-in buttons shown under an upload refused with 401/403. */
export default function UploadAccountLinks({ color }) {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 1 }}>
            <Link to="/auth/register" style={{ textDecoration: 'none' }}>
                <Button size="small" variant="outlined" sx={{ borderColor: color, color }}>
                    Register (free)
                </Button>
            </Link>
            <Link to="/auth/login" style={{ textDecoration: 'none' }}>
                <Button size="small" variant="text" sx={{ color }}>
                    Log in
                </Button>
            </Link>
        </Box>
    );
}
